import 'jquery';
import 'masonry-layout/dist/masonry.pkgd'
import $ from "jquery";
import _ from 'lodash';
import isTouchDev from './isTouchDev';
import isIEBrowser from './isIEBrowser';

/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

const masonryOptions = {
    itemSelector: '.grid-item',
    columnWidth: '.grid-sizer',
    percentPosition: true,
    gutter: 18,
    horizontalOrder: true,
};

class LoadMoreNews {
    constructor($wrapper, $grid, $button, pageId) {
        this.$wrapper = $wrapper;
        this.$grid = $grid;
        this.$button = $button;
        this.newsPageNumber = 1;
        this.newElements = [];
        this.pageId = pageId;
        this.newsType = 'Aktuellt'
    }

    getNews(init = false) {
        this._inactivateButton();
        this.newElements = [];

        let data_category_id = document.querySelector('[data-category-id]'),
            category_id = data_category_id.getAttribute('data-category-id'),
            is_news_category_page = category_id !== '' && category_id !== '0',
            cat_ajax_data = {
                pageNumber: this.newsPageNumber,
                postsPerPage: 7,
                action: 'get_more_news_action',
            }
            
        if (is_news_category_page) {
            this.cat_id = data_category_id.getAttribute('data-category-id')
            cat_ajax_data = {
                pageNumber: this.newsPageNumber,
                postsPerPage: 7,
                action: 'get_more_posts_action',
                category: this.cat_id,
            }
        }

        $.ajax({
            type: "GET",
            dataType: "json",
            url: window.ajaxurl,
            data: cat_ajax_data,
            success: (res) => {
                this.newsPageNumber++;
                if (res.news.length) {
                    this._parseResult(init, res.news);
                }
                if (!res.is_next_available) {
                    this._hideButton();
                }
            },
            error: (error) => {
                console.error(error);
                this._activateButton();
            },
        });
    }

    _parseResult(init, news) {
        $.each(news, (index, post) => {
            const $html = `
                       <div class="news-item grid-item">
                           <div class="frame">
                           <div class="photo-block">
                                <img src="${post[0]}" alt="">
                                <div class="publish-date">
                                    <span class="text-el">${post[2]}</span>
                                </div>
                            </div>
                            <div class="news-content">
                                <div class="author">
                                    ${post[2].toLowerCase()} -
                                    <span class="news-type">${post[6] || this.newsType}</span>
                                </div>
                                <div class="title">${post[3]}</div>
                                <div class="description">${post[4]}</div>
                                <div class="btn-share js-share">
                                    <i class="fa fa-share-alt" aria-hidden="true"></i>
                                    <ul class="networks-wrapper">
                                        <li class="facebook">
                                            <a href="https://www.facebook.com/sharer/sharer.php?u=${post[5]}" target="_blank" aria-label="facebook share">
                                                <i class="fa fa-facebook" aria-hidden="true"></i>
                                            </a>
                                        </li>
                                        <li class="twitter">
                                            <a href="https://twitter.com/home?status=${post[5]}" target="_blank" aria-label="twitter share">
                                                <i class="fa fa-twitter" aria-hidden="true"></i>
                                            </a>
                                        </li>
                                        <li class="google">
                                            <a href="https://plus.google.com/share?url=${post[5]}" target="_blank" aria-label="google+ share">
                                                <i class="fa fa-google-plus" aria-hidden="true"></i>
                                            </a>
                                        </li>
                                        <li class="pinterest">
                                            <a href="https://pinterest.com/pin/create/button/?url=${post[5]}" target="_blank" aria-label="pinterest share">
                                                <i class="fa fa-pinterest" aria-hidden="true"></i>
                                            </a>
                                        </li>
                                        <li class="linkedin">
                                            <a href="https://www.linkedin.com/shareArticle?mini=true&url=${post[5]}" target="_blank" aria-label="linkedin share">
                                                <i class="fa fa-linkedin" aria-hidden="true"></i>
                                            </a>
                                        </li>
                                        <li class="mail">
                                            <a href="mailto: info@murberget.se?&body=${post[5]}" aria-label="email share">
                                                <i class="fa fa-envelope" aria-hidden="true"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <a  href="${post[5]}" class="read-more">Läs mer</a>
                            </div>
                            <a href="${post[5]}" aria-label="${post[3]}"></a>
                            </div>
                            
                    </div>
                    `;
            const $item = $($html);
            this.newElements.push($item[0]);
        });
        this._addNewsToGrid(init, this.newElements);
    }

    _addNewsToGrid(init, elements) {
        if(init) {
            setTimeout(() => {
                this.$grid.append(elements);
                if (!isTouchDev() && !isIEBrowser()) this.$grid.masonry(masonryOptions);
                this._activateButton();
            }, 1000);
        } else {
            setTimeout(() => {
                this.$grid.append(elements);
                if (!isTouchDev() && !isIEBrowser()) this.$grid.masonry('appended', elements).masonry('layout');
                this._activateButton();
            }, 1000);
        }
    }

    _activateButton() {
        this.$button.removeClass('inactive');
    }

    _inactivateButton() {
        this.$button.addClass('inactive');
    }

    _hideButton() {
        this.$button.hide();
    }
}

class LoadMoreFbNews extends LoadMoreNews {
    getNews(init = false) {
        this._inactivateButton();
        this.newElements = [];
        $.ajax({
            type: "GET",
            dataType: "json",
            url: window.ajaxurl,
            data: ({
                request: this.$button.attr('data-request'),
                action: 'get_more_fb_news_action',
                pageId: this.pageId,
            }),
            success: (res) => {
                if (res.news.length) {
                    this._parseResult(init, res.news);
                }
                if (_.isEmpty(res.paging)) {
                    this._hideButton();
                } else {
                    this._updateButton(res.paging);
                }
            },
            error: (error) => {
                console.error(error);
                this._activateButton();
            },
        });
    }

    _parseResult(init, news) {
        $.each(news, (index, post) => {
            const content = post[3].length > 240 ? post[3].substring(0, 240) + '<span class="three-dots">...</span>' : post[3];
            const $html = `
                       <div class="news-item grid-item">
                            <div class="frame">
                                <div class="photo-block">
                                    <img src="${post[0]}" alt="">
                                    <div class="social-logo fb">
                                        <i class="fa fa-facebook-official" aria-hidden="true"></i>
                                    </div>
                                </div>
                                <div class="news-content">
                                    <div class="author">
                                        By  in
                                        <span class="news-type">Facebook</span>
                                    </div>
                                    <div class="title"></div>
                                    <div class="description">${content}</div>
                                    <div class="btn-share js-share">
                                        <i class="fa fa-share-alt" aria-hidden="true"></i>
                                        <ul class="networks-wrapper">
                                            <li class="facebook">
                                                <i class="fa fa-facebook" aria-hidden="true"></i>
                                            </li>
                                            <li class="twitter">
                                                <i class="fa fa-twitter" aria-hidden="true"></i>
                                            </li>
                                            <li class="google">
                                                <i class="fa fa-google-plus" aria-hidden="true"></i>
                                            </li>
                                            <li class="pinterest">
                                                <i class="fa fa-pinterest" aria-hidden="true"></i>
                                            </li>
                                            <li class="linkedin">
                                                <i class="fa fa-linkedin" aria-hidden="true"></i>
                                            </li>
                                            <li class="mail">
                                                <i class="fa fa-envelope" aria-hidden="true"></i>
                                            </li>
                                        </ul>
                                    </div>
                                    <a href="${post[1]}" class="read-more" target="_blank" >Läs mer</a>
                                </div>
                                <a href="${post[1]}" target="_blank" aria-label="${content}"></a>
                            </div>
                        </div>
                    `;
            const $item = $($html);
            this.newElements.push($item[0]);
        });
        this._addNewsToGrid(init, this.newElements);
    }

    _updateButton(attr) {
        this.$button.attr('data-request', attr);
    }
}

class LoadMoreInstaNews extends LoadMoreNews {
    getNews(init = false) {
        this._inactivateButton();
        this.newElements = [];
        $.ajax({
            type: "GET",
            dataType: "json",
            url: window.ajaxurl,
            data: ({
                request: this.$button.attr('data-request'),
                action: 'get_more_inst_news_action',
                pageId: this.pageId,
            }),
            success: (res) => {
                if (res.news.length) {
                    this._parseResult(init, res.news);
                }
                if (_.isEmpty(res.paging)) {
                    this._hideButton();
                } else {
                    this._updateButton(res.paging.next_url);
                }
            },
            error: (error) => {
                console.error(error);
                this._activateButton();
            },
        });
    }

    _parseResult(init, news) {
        $.each(news, (index, post) => {
            const content = post[2].length > 240 ? post[2].substring(0, 240) + '<span class="three-dots">...</span>' : post[2];
            const $html = `
                       <div class="news-item grid-item">
                            <div class="frame">
                            <div class="photo-block">
                                <img src="${post[1]}" alt="">
                                <div class="social-logo insta">
                                    <i class="fa fa-instagram" aria-hidden="true"></i>
                                </div>
                            </div>
                            <div class="news-content">
                                <div class="author">
                                    By  in
                                    <span class="news-type">${post[0]}</span>
                                </div>
                                <div class="comment-like">
                                    <div class="coments">${post[4]}</div>
                                    <div class="likes">${post[3]}</div>
                                </div>
                                <div class="title"></div>
                                <div class="description">${content}</div>
                                <div class="btn-share js-share">
                                    <i class="fa fa-share-alt" aria-hidden="true"></i>
                                    <ul class="networks-wrapper">
                                        <li class="facebook">
                                            <i class="fa fa-facebook" aria-hidden="true"></i>
                                        </li>
                                        <li class="twitter">
                                            <i class="fa fa-twitter" aria-hidden="true"></i>
                                        </li>
                                        <li class="google">
                                            <i class="fa fa-google-plus" aria-hidden="true"></i>
                                        </li>
                                        <li class="pinterest">
                                            <i class="fa fa-pinterest" aria-hidden="true"></i>
                                        </li>
                                        <li class="linkedin">
                                            <i class="fa fa-linkedin" aria-hidden="true"></i>
                                        </li>
                                        <li class="mail">
                                            <i class="fa fa-envelope" aria-hidden="true"></i>
                                        </li>
                                    </ul>
                                </div>
                                <a  href="${post[5]}" target="_blank" class="read-more">Läs mer</a>
                            </div>
                            <a href="${post[5]}" target="_blank" aria-label="${content}"></a>
                            </div>
                            
                        </div>
                    `;
            const $item = $($html);
            this.newElements.push($item[0]);
        });
        this._addNewsToGrid(init, this.newElements);
    }

    _updateButton(attr) {
        this.$button.attr('data-request', attr);
    }
}

export default () => {
    const $instGrid = $('.js-inst-grid');
    const $fbGrid = $('.js-fb-grid');

    // share buttons
    $('body').on('click','.js-share',function(e) {
        e.stopPropagation();
        let $this = $(this);
        $this.find('.networks-wrapper').toggle();
    });

    /** actual News **/
    const $newsWrapper = $('.js-news-wrapper');
    const $newsGrid = $('.js-news-grid');
    const $loadMoreNewsButton = $('.js-news-load-more');
    if ($newsWrapper.length) {
        const actualNews = new LoadMoreNews($newsWrapper, $newsGrid, $loadMoreNewsButton, $newsWrapper.attr('data-page-id'));
        // init masonry and get get first 7 news
        $(window).on('load', () => {
            if (!isTouchDev() && !isIEBrowser()) {
                $instGrid.masonry(masonryOptions);
                $fbGrid.masonry(masonryOptions);
            }
            actualNews.getNews(true);
        });
        // get next 7 news by click
        $loadMoreNewsButton.click(function () {
            actualNews.getNews();
        });        
    }

    /** facebook News **/
    const $fbNewsWrapper = $('.js-fb-wrapper');
    const $loadMoreFbNewsButton = $('.js-fb-load-more');
    const fblNews = new LoadMoreFbNews($fbNewsWrapper, $fbGrid, $loadMoreFbNewsButton, $fbNewsWrapper.attr('data-page-id'));
    // get next 7 news by click
    $loadMoreFbNewsButton.click(function () {
        fblNews.getNews();
    });

    /** instaram News **/
    const $instaNewsWrapper = $('.js-insta-wrapper');
    const $loadMoreNewsInstaButton = $('.js-inst-load-more');
    const instaNews = new LoadMoreInstaNews($instaNewsWrapper, $instGrid, $loadMoreNewsInstaButton, $instaNewsWrapper.attr('data-page-id'));
    // get next 7 news by click
    $loadMoreNewsInstaButton.click(function () {
        instaNews.getNews();

    })
};


// WEBPACK FOOTER //
// ./scripts/modules/news.js